<template>
  	<div>
	  	<div class="main" v-lazy:background-image="{src: lazyImg.bigBgc}">
			<div class="content">
				<!-- logo--start -->
				<div class="logo">
					<a href="https://www.pcauto.com.cn/" class="logo_tpy">
						<img v-lazy="lazyImg.logoTpy" :key="lazyImg.logoTpy" alt="">
					</a>
					<a href="https://www.geeknev.com/" class="logo_jd">
						<img v-lazy="lazyImg.logoJd" :key="lazyImg.logoJd" alt="">
					</a>
				</div>
		  		<!-- logo--end -->

				<!-- 视频区--start -->
				<div class="video" v-if="videoList">
					<div class="video_border" v-lazy:background-image="{src: lazyImg.border1}"></div>
					<div class="video_content fl-ai-jcb">
						<div class="video_l">
							<a href="javascript:void(0)" @click="controlStop()">
								<i @click.stop="controlPlay()" v-show="!videoPlay && videoList[videoSelIndex]" id="playBtn"></i>
							</a>
							<video autoplay loop :src="videoList[videoSelIndex] && videoList[videoSelIndex].url || ''" :poster="videoList[videoSelIndex] && videoList[videoSelIndex].coverUrl || ''">
							</video>
						</div>
						<div class="video_r">
							<div class="scroll_content" style="height:460px">
								<div v-for="(item, index) in videoList" :key="index" :class="{video_item:true,video_selected:index == videoSelIndex} ">
									<div class="video_item_v" @click="changeVideo(index)">
										<img v-lazy="item.coverUrl" :key="item.coverUrl" alt="">
										<i></i>
									</div>
									<div class="video_item_text" >{{item.name}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 视频区--end -->

		  		<!-- 指数排行榜--start -->
				<div class="rank" v-if="tabList">
					<div class="rank_title" v-lazy:background-image="{src: lazyImg.titleBig1}"></div>
					<div class="rank_intro" v-lazy:background-image="{src: lazyImg.border2}">
						<p>
							{{rankIntro}} 
							<router-link :to="{ path: '/inside'}" tag="a">查看更多></router-link>
						</p>
					</div>
					<div class="rank_tab">
						<tabModel :tabList="tabList" :TabSelIndex="rankTabSelIndex" showName="tabName" @changeTab="changeTab"></tabModel>
						<div class="rank_tab_b">
							<div 
								v-for="(item,index) in tabList[rankTabSelIndex] && tabList[rankTabSelIndex].serials.slice(0,len) || []" 
								:key="index" 
								:class="{rank_item:true,rank_no1:index == 0}" 
								id="rankItemId"
							>
								<div class="rank_item_body fl-ai-jcb">
									<div class="rank_body_l fl-ai">
										<div class="rank_body_ll fl-ai-jc">
											<a :href="item.serialUrl || 'javascript:void(0)'">
												<img v-lazy="item.picUrl" :key="item.picUrl" alt="">
											</a>
											<i class="rank_flag">N0.{{item.rank || ""}}</i>
										</div>
										<div class="rank_body_lr ">
											<div class="rank_carName">{{item.name || ""}}
												<p v-show="index != 0 && rankTabSelIndex == 0">ICT300测试总分</p>
												<p v-show="index != 0 && rankTabSelIndex != 0">ICT300{{tabList[rankTabSelIndex].tabName}}测试总分</p>
											</div>
											<div class="rank_price"  v-show="rankTabSelIndex != 0 && index == 0">{{item.priceRange || "" || ""}}</div>
											<div class="rank_mark_t" v-show="index == 0 && rankTabSelIndex == 0">ICT300测试总分</div>
											<div class="rank_mark_t" v-show="index == 0 && rankTabSelIndex != 0">ICT300{{tabList[rankTabSelIndex].tabName}}测试总分</div>
											<div class="rank_mark">
												<span>{{item.totalScore || "0"}}</span>分
											</div>
											<div class="rank_body_r1" v-show="index != 0">
												<div class="rank_price">{{item.priceRange || ""}}</div>
												<a :href="item.serialUrl || 'javascript:void(0)'" class="rank_detail_btn">车系详情</a>
											</div>
										</div>
									</div>
									<div class="rank_body_r ">
										<div :class="['rank_body_r1',rankTabSelIndex != 0 && index == 0?'rankTab2':'fl-ai-jr']" v-show="index == 0">
											<div class="rank_body_r2" v-show="rankTabSelIndex != 0 && index == 0">
												<div>测试版本 {{item.modelName || ""}}</div>
												<div>测试时间 {{item.examTime || ""}}</div>
											</div>
											<div class="rank_price"  v-show="rankTabSelIndex == 0">{{item.priceRange || ""}}</div>
											<a :href="item.serialUrl || 'javascript:void(0)'" class="rank_detail_btn">车系详情</a>
										</div>
										<div class="rank_body_r2 fl-jcb" v-show="rankTabSelIndex == 0 || index != 0">
											<span>测试版本 {{item.modelName || ""}}</span>
											<span>测试时间 {{item.examTime || ""}}</span>
										</div>
										<div class="rank_body_r3" v-if="rankTabSelIndex == 0">
											<!-- 综合排行 -->
											<div class="grogress_box fl-ai-jcb" >
												<div v-for="(item2,index2) in item.moduleList || []" :key="index2" class="grogress_item" >
													<!-- {{item2.score}}   {{item2.fullScore}} -->
													<router-link :to="{ path: '/detail?evaluationId='+item.evaluationId+'&moduleIndex='+index2}" tag="a">
														<el-progress type="circle" :percentage="(item2.score/item2.fullScore)*100 || 0"  color="#0fc4ff" :width="index == 0 ? 110 : 95">
														</el-progress>
														<div class="grogress_text">
															<div class="grogress_price">{{item2.score || "0"}}分</div>
															<div class="grogress_type">{{item2.name || ""}}</div>
														</div>
													</router-link>
												</div>
											</div>
											<div class="overThree" v-show="item.moduleList && item.moduleList.length>3">
												<i @click="rollGrogress($event,'left')" class="moveL"></i>
												<i @click="rollGrogress($event,'right')" class="moveR"></i>
											</div>
										</div>
										<div class="rank_body_r3" v-if="rankTabSelIndex != 0">
											<!-- 其他的 -->
											<div  class="grogress_box fl-ai-jcb">
												<div v-for="(item2,index2) in item.moduleList[rankTabSelIndex-1].itemList || []" :key="index2" class="grogress_item" >
													<!-- {{item2.score}}  {{item2.fullScore}} -->
													<router-link :to="{ path: '/detail?evaluationId='+item.evaluationId+'&moduleIndex='+(rankTabSelIndex-1)}" tag="a">
														<el-progress type="circle" :percentage="(item2.score/item2.fullScore)*100 || 0" color="#0fc4ff" :width="index == 0?100:90">
														</el-progress>
														<div class="grogress_text">
															<div class="grogress_price">{{item2.score || "0"}}分</div>
															<div class="grogress_type">{{item2.name || ""}}</div>
														</div>
													</router-link>
												</div>
											</div>
											<div class="overThree" v-show="item.moduleList[rankTabSelIndex-1].itemList && item.moduleList[rankTabSelIndex-1].itemList.length>3">
												<i @click="rollGrogress($event,'left')" class="moveL"></i>
												<i @click="rollGrogress($event,'right')" class="moveR"></i>
											</div>
										</div>
									</div>
								</div>
								<div class="rank_item_comment">
									<div class="comment_item fl">
										<div class="rank_comment_pic">
											<img :src="item.reviewerList[0] && item.reviewerList[0].faceUrl" alt="">
										</div>
										<div :class="{rank_comment_text:true,rank_open_text:item.isOpen}">
											<p>
												<span class="comment_name">{{item.reviewerList[0] && item.reviewerList[0].name}}</span>
												<span class="comment_status">卓越车评人</span>
												{{item.reviewerList[0] && item.reviewerList[0].content}}
											</p>
											<i @click="openComment(item)"></i>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="len < tabListLength" class="getmore" @click="loadMore">查看更多></div>
					<div v-else class="expect">更多车型正在测评中，敬请期待</div>
				</div>
				<!-- 指数排行榜--end -->

				<!-- 排行榜精华选集--start -->
				<div class="bestrank" v-if="essenceCollections">
					<div class="bestrank_title" v-lazy:background-image="{src: lazyImg.titleBig2}"></div>
					<tabModel :tabList="essenceCollections" :TabSelIndex="bestRankIndex" showName="name" @changeTab="changeBestTab"></tabModel>
					<div class="review" v-if="essenceCollections[bestRankIndex] && essenceCollections[bestRankIndex].articleList.length">
						<div class="review_t"></div>
						<div class="review_outerbox">
							<div class="review_box">
								<div class="review_b">
									<div 
										v-for="(item,index) in essenceCollections[bestRankIndex] && essenceCollections[bestRankIndex].articleList || []" 
										:key="index" class="review_b_item" 
										v-lazy:background-image="{src: lazyImg.border3}"
									>
										<a :href="item.url || 'javascript:void(0)'">
											<div class="review_img">
												<img v-lazy="item.picUrl" :key="item.picUrl" alt="">
											</div>
											<h5>{{item.title}}</h5>
											<h6>{{item.author}} {{item.time}}</h6>
										</a>
									</div>
								</div>
							</div>
							<i class="review_moveL" v-show="essenceCollections[bestRankIndex] && essenceCollections[bestRankIndex].articleList.length>3" @click="rollReview($event,'left')"></i>
							<i class="review_moveR" v-show="essenceCollections[bestRankIndex] && essenceCollections[bestRankIndex].articleList.length>3" @click="rollReview($event,'right')"></i>
						</div>
					</div>
					<div class="summary" v-if="essenceCollections[bestRankIndex] && essenceCollections[bestRankIndex].videoList.length">
						<div class="summary_t"></div>
						<div :class="{summary_box:true, hiddenMore:!showMoreSum}">
							<div 
								v-for="(item,index) in essenceCollections[bestRankIndex] && essenceCollections[bestRankIndex].videoList" 
								:key="index" class="summary_item" 
								v-lazy:background-image="{src: lazyImg.border4}"
							>
								<a href="javascript:void(0)" @click="openVideo(item.url)">
									<div class="summary_img">
										<img v-lazy="item.coverUrl" :key="item.coverUrl" alt="">
										<i>{{item.duration}}</i>
										<em></em>
									</div>
									<h5>{{item.name}}</h5>
								</a>
							</div>
						</div>
						<div class="btn_more" @click="showMoreSum=!showMoreSum" v-show="essenceCollections[bestRankIndex] && essenceCollections[bestRankIndex].videoList.length>4">{{showMoreSum?'隐藏':'查看更多'}}</div>
					</div>
				</div>
				<!-- 排行榜精华选集--end -->

				<!-- 极智相关内容推荐--start -->
				<div class="recommend" v-if="jizhiContents">
					<div class="recommend_t" v-lazy:background-image="{src: lazyImg.titleBig3}"></div>
					<div class="recommend_box">
						<div v-for="(item,index) in jizhiContents" :key="index" class="recommend_item" v-lazy:background-image="{src: lazyImg.border5}">
							<a :href="item.url || 'javascript:void(0)'">
								<div class="recommend_img">
									<img v-lazy="item.picUrl" :key="item.picUrl" alt="">
									<div class="authorFaceBox">
										<i><img v-lazy="item.authorFaceUrl" :key="item.authorFaceUrl" alt=""></i>
										<em>{{item.authorName}}</em>
									</div>
								</div>
							</a>
							<div class="recommend_text fl-ai-jcb">
								<h5><a :href="item.url || 'javascript:void(0)'">{{item.title}}</a></h5>
								<a :href="item.url || 'javascript:void(0)'">{{item.articleMark}}></a>
							</div>
						</div>
					</div>
				</div>
				<!-- 极智相关内容推荐--end -->
				<!-- <el-button type="text" @click="showDialog = true">打开嵌套表格的 Dialog</el-button> -->
				<videoDialog :videoUrl="curVideoUrl" ref="videoDialog"></videoDialog>
				<div class="bottom_flag">—— 页面已经到底啦 ——</div>
			</div>
		</div>
	</div>
</template>
<script>
import "@/tool/jquery.cookie.js"
import tabModel from "@/components/tab"
import videoDialog from "@/components/videoDialog"
import commonjs from "@/common/common.js"
export default {
  	components: {
		tabModel,
		videoDialog
  	},
  	data() {
		return {
			lazyImg:{
				bigBgc:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/bgc.jpg",
				logoTpy:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/logo_tpy.png",
				logoJd:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/logo_jd.png",
				border1:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/border1.png",
				border2:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/border2.png",
				titleBig1:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/title_big1.png",
				titleBig2:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/title_big2.png",
				titleBig3:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/title_big3.png",
				border3:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/border3.png",
				border4:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/border4.png",
				border5:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/border5.png",
			},
			isShowPage:false,
			// issue:"",
			rankIntro:"基于太平洋汽车首创ICT300智能汽车评测标准，联合中汽中心、上海智能网测试基地实测，定期发布量产在售智能汽车ICT指数排行。",
			videoPlay:false,
			videoSelIndex:0,
			videoList:[],
			rankTabList:["综合排行","自动驾驶","智能座舱","性能测试"],
			rankTabSelIndex:0,
			tabList:[],
			isMove:false,
			// 排行榜精华集选
			essenceCollections:[],
			bestRankIndex:0,
			showMoreSum:false,
			jizhiContents:[],
			curVideoUrl:"",
			tabListLength:0,    //指数排行榜的条数
			len:8,             //默认显示的条数
		}
  	},
	mounted() {
		// 站内+站外（传栏目ID，cms）
		this.count(10442, 'cms');
		var rfef = document.referrer || "";
		// 站内（传埋点ID，event）
		if (rfef.indexOf('pcauto.com.cn') != -1) {
			this.count(13604, 'event')
		}

		// 设置进度条
		this.setGrogress();

		// 获取测评报告数据
		this.getEvaluationIndex();

		//获取顶部视频
		this.getIndexVideo();

		//获取排行榜精华集选
		this.getRankContent();

		//获取极智相关内容推荐
		this.getRelatedContent();
	},
	methods: {
		controlPlay(){
			var video = $(".video_l video")[0];
			if(video.paused){
				video.play();
				this.videoPlay = true;
			}
		},
		controlStop(){
			var video = $(".video_l video")[0];
			if(!video.paused){
				video.pause();
				this.videoPlay = false;
			}
		},
		changeVideo(index){
			this.videoSelIndex = index;
			$(".video_l video").attr("autoplay",true)
			this.videoPlay = true;
		},
		changeTab(index){
			this.rankTabSelIndex = index;
			this.setGrogress();
			this.isShowOpenIcon();
			$(".grogress_box").css("left","0px");
		},
		changeBestTab(index){
			this.bestRankIndex = index;
			$(".review_b").css("left","0px");
			this.showMoreSum = false;
		},
		setGrogress(){
			// 设置进度条
			setTimeout(()=>{
				$(".rank_body_r3 .el-progress-circle").find("path").attr("stroke-width","10")
				$(".rank_body_r3 .el-progress").find("path:first").attr("stroke","#051338")
				$(".rank_body_r3 .el-progress-circle").find("svg").css("overflow","visible")
				$(".rank_body_r3 .el-progress").css("transform","rotate(180deg)")
				$(".rank_body_r3 .el-progress .el-progress__text").text("")
			},0)
		},
		// 首页测评报告2020
		getEvaluationIndex(){
			let params = {
				url: 'getEvaluationIndex',
				method: 'get',
			};
			this.$axios(params).then((res) => {
				this.tabList = res.tabList;
				this.tabListLength = this.tabList[0].serials.length;
				this.isShowOpenIcon();
				for(let i=0; i<this.tabList.length; i++){
					let  serialsList= this.tabList[i].serials;
					for (let j = 0; j<serialsList.length; j++){
						let serialId = serialsList[j].serialId;
						serialsList[j].serialUrl = "http://price.pcauto.com.cn/sg" + serialId +"/";
					}
				}
				this.setGrogress();
				// 根据评议的长短来控制对应图标的显示与否
				this.isShowOpenIcon()
				this.isShowPage = true;
			}).catch(err => {
				alert(err)
			});
		},
		// 首页顶部视频
		getIndexVideo(){
			let params = {
				url: 'getIndexVideo',
				method: 'get',
			};
			this.$axios(params).then((res) => {
				this.videoList = res.videoList;
				this.isShowPage = true;
				this.$nextTick(()=>{
					var video = $(".video_l video")[0];
					video.addEventListener("playing",()=>{
						this.videoPlay = true;
					})
					video.addEventListener("pause",()=>{
						this.videoPlay = false;
					})
				})
			}).catch(err => {
				alert(err)
			});
		},
		//获取极智相关内容推荐
		getRelatedContent(){
			let params = {
				url: 'getRelatedContent',
				method: 'get',
			};
			this.$axios(params).then((res) => {
				this.jizhiContents = res.jizhiContents;
				this.isShowPage = true;
			}).catch(err => {
				alert(err)
			});
		},
		//获取排行榜精华集选
		getRankContent(){
			let params = {
				url: 'getRankContent',
				method: 'get',
			};
			this.$axios(params).then((res) => {
				this.essenceCollections = res.essenceCollections;
				this.isShowPage = true;
			}).catch(err => {
				alert(err)
			});
		},
		isShowOpenIcon(){
			setTimeout(()=>{
				$(".rank_comment_text p").each(function(){
					if($(this).css("height").substring(0,$(this).css("height").indexOf("p"))<50){
						$(this).parent().find("i").css("display","none")
					} else {
						$(this).parent().find("i").css("display","block")
					}
				});
			},0)
		},
		rollGrogress(e,type){
			var that = this;
			if(!that.isMove){
				var rankBodyR3 = $(e.currentTarget.parentElement).parent();
				var boxElement = rankBodyR3.find(".grogress_box");
				var itemElement = boxElement.find(".grogress_item");
				var itemWidth = itemElement.css("width").substring(0,itemElement.css("width").indexOf("p"));
				var itemMR = itemElement.css("marginRight").substring(0,itemElement.css("marginRight").indexOf("p"));
				var moveLength = (itemWidth-0) + (itemMR-0);
				var allMoveLength = moveLength * (itemElement.length-3);
				moveLength = moveLength*3;
				var left = boxElement.css("left").substring(0,boxElement.css("left").indexOf("p"));
				this.animateFun(left,moveLength,allMoveLength,type,boxElement,600,()=>{
				if(type == "right"){
					that.isMove = false;
					rankBodyR3.find(".moveL").css("display","block")
				}else{
					that.isMove = false;
					if(Math.abs(left-0)<moveLength+5){
						rankBodyR3.find(".moveL").css("display","none")
					}
				}
				})
			}
		},
		rollReview(e,type){
			var that = this;
			if(!that.isMove){
				var outerbox = $(e.currentTarget.parentElement).parent();;
				var boxElement = outerbox.find(".review_b");
				var itemElement = boxElement.find(".review_b_item");
				var itemWidth = itemElement.css("width").substring(0,itemElement.css("width").indexOf("p"));
				var itemMR = itemElement.css("marginRight").substring(0,itemElement.css("marginRight").indexOf("p"));
				var moveLength = (itemWidth-0) + (itemMR-0);
				var allMoveLength = moveLength * (itemElement.length-3);
				moveLength = moveLength*3;
				var left = boxElement.css("left").substring(0,boxElement.css("left").indexOf("p"));
				this.animateFun(left,moveLength,allMoveLength,type,boxElement,800,()=>{
					if(type == "right"){
						that.isMove = false;
					}else{
						that.isMove = false;
					}
				})
			}
		},
		// 移动封装
		// left：当前的left值,moveLength：一次移动的长度，allMoveLength：总共能移动的距离，type：左移还是右移，boxElement：移动的对象，time:移动的时间，fun:回调函数
		animateFun(left,moveLength,allMoveLength,type,boxElement,time,fun=null){
			var that = this;
			if(Math.abs(left-0)<allMoveLength-5 && type == "right"){
				that.isMove = true;
				boxElement.animate({left:left-moveLength},  
				time,
				"linear",
				function() {
					fun()
				});
			}
			if(Math.abs(left-0)>5 && type == "left"){
				that.isMove = true;
				boxElement.animate({left:left-0+moveLength},  
				time,
				"linear",
				function() {
					fun()
				});
			}
		},
		openComment(item){
			item.isOpen = item.isOpen ? false : true;
			this.$forceUpdate()
		},
		openVideo(url){
			this.curVideoUrl = url;
			this.$refs.videoDialog.showDialog()
		},
		count: function(id, type) {
			type = type || 'event';
			var img = new Image;
			img.src = "//count.pcauto.com.cn/count.php?channel="+ id +"&screen=" + screen.width +"*"+ screen.height + "&refer="+encodeURIComponent(document.referrer)+"&anticache="+new Date().getTime()+"&url="+encodeURIComponent(location.href)+"&from="+type;
		},
		//指数排行加载更多
		loadMore(){
			this.setGrogress();
			this.isShowOpenIcon();
			this.len += 8;
		}
	}
}
</script>
<style lang="less" scoped>
	body{
		background: #07143e;
	}
	.main{
		padding-bottom: 50px;
		margin-bottom: 40px;
		background-color: #051338;
		background-position: center top;
		background-repeat: no-repeat;
		min-width: 1180px;
		width: 100%;
		color: #d8fcff;
		min-height: 1000px;
		.content{
			max-width: 1180px;
			min-width: 960px;
			margin:0 auto;
			.logo{
				padding-top: 24px;
				img{
					width: 100%;
				}
				.logo_tpy{
					width: 175px;
					height: 40px;
					display: inline-block;
					position: relative;
					top: 23px;
					margin-right: 48px;
					cursor: pointer;
				}
				.logo_jd{
					width: 119px;
					height: 63px;
					display: inline-block;
					cursor: pointer;
				}
			}
			.sub_title{
				background: url(https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/title_bgc3.png) no-repeat center top;;
				width: 630px;
				height: 65px;
				margin:208px auto;
				text-align: center;
				line-height: 65px;
				font-size: 30px;
			}
			.video{
				margin:630px auto 0;
				overflow: hidden;
				position: relative;
				width: 1180px;
				height: 497px;
				.video_border{
					background-position: center top;
					background-repeat: no-repeat;
					width: 1180px;
					height: 497px;
					position: absolute;
					top: 0;
					left: 0;
					z-index: 10;
				}
				.video_content{
					padding: 12px 20px 0 14px;
					display: flex;
					.video_l{
						height: 100%;
						position: relative;
						overflow: hidden;
						flex: 3;
						video{
							height:483px;
						}
						a{
							width: 100%;
							height: 100%;
							display:inline-block;
							position: absolute;
							left: 0;
							right: 0;
							z-index: 11;
							i{
								cursor: pointer;
								position: absolute;
								left: 50%;
								top: 50%;
								transform: translate(-50%,-50%);
								background: url(https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/play_btn.png) center no-repeat;
								width: 100px;
								height: 100px;
								display: inline-block;
								z-index: 12;
							}
						}
						
					}
					.video_r{
						flex: 1;
						height: 471px;
						width: 300px;
						position: relative;
						z-index: 12;
						overflow-x: hidden;
						overflow-y: auto;
						padding-right: 5px;
						.happy-scroll{
							height: 460px;
						}
						.scroll_content{
							padding-left: 12px;
							padding-right: 2px;
							.video_item{
								box-sizing:border-box;
								height: 235px;
								overflow: hidden;
								position: relative;
								padding-top: 10px;
								.video_item_v{
									position: relative;
									cursor: pointer;
									img{
										width: 265px;
									}
									i{
										position: absolute;
										left: 50%;
										top: 50%;
										transform: translate(-50%,-50%);
										background: url(https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/play_btn.png) center no-repeat;
										width: 50px;
										height: 50px;
										display: inline-block;
										background-size: 50px;
									}
								}
								.video_item_text{
									width: 265px;
									margin-top: 10px;
									font-size: 16px;
									max-height: 56px;
									line-height: 28px;
									overflow: hidden;
									color: #2e6d90;
								}
								
							}
							.video_selected{
								.video_item_text{
									color: #58effa;
								}
								img{
									border: 2px solid #58effa;
								}
								i{
									display: none!important;
								}
							}
						}
						
					}
				}
			}
			.rank{
				margin-top: 74px;
				.rank_title{
					background-position: center top;
					background-repeat: no-repeat;
					width: 568px;
					height: 81px;
					margin: 0 auto;
				}
				.rank_intro{
					font-size: 16px;
					background-position: center top;
					background-repeat: no-repeat;
					width: 1182px;
					height: 157px;
					margin: 0 auto;
					position: relative;
					top: -7px;
					padding: 18px 0;
					p{
						width: 70%;
						max-height: 56px;
						line-height: 28px;
						overflow: hidden;
						margin: 0 auto;
						text-align: center;
						position: absolute;
						left:50%;
						top: 50%;
						transform: translate(-50%,-50%);
						a{
							color: #58effa;
							cursor: pointer;
						}
					}
				}
				.rank_tab{
					margin-top: 70px;
					.rank_tab_b{
						margin-top: 20px;
						.rank_item{
							border-bottom: 1px solid #11326b;
							padding: 50px 0;
							box-sizing: border-box;
							overflow: hidden;
							.rank_item_body{
								.rank_body_l{
									width: 813px;
									border-right: 1px solid #11326b;
									padding-right: 20px;
									box-sizing: border-box;
								.rank_body_ll{
									width: 286px;
									height: 200px;
									text-align: center;
									position:relative;
									a{
										cursor: pointer;
										width: 100%;
										img{
											width: 90%;
										}
									}
									.rank_flag{
										font-style: italic;
										font-size: 24px;
										color:#58effa;
										font-weight: 700;
										width: 66px;
										height: 51px;
										line-height: 66px;
										position: absolute;
										top: 0;
										left: 0;
										text-align: center;
									}
								}
								.rank_body_lr{
									width: 527px;
									display: flex;
									position: relative;
									align-items: center;
									.rank_carName{
										width: 167px;
										margin-right: 4px;
										font-size: 28px;
										font-weight: 700;
										line-height: 36px;
										position: relative;
										p{
											font-size: 16px;
											color:#26adbd;
											line-height: 23px;
											margin-top: 10px;
										}
									}
									.rank_mark_t{
										font-size: 16px;
										color:#26adbd;
										position: absolute;
										top: 50px;
										// max-width: 192px;
									}
									.rank_mark{
										text-align: center;
										width: 180px;
										font-size: 30px;
										white-space:nowrap;
										margin-right: 15px;
										span{
											font-size: 80px;
											font-weight: 700;
											margin-right: 5px;
										}
									}
									.rank_body_r1{
										height: 60px;
										.rank_price{
											white-space:nowrap;
											line-height: 30px;
										}
										.rank_detail_btn{
											background: url(https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/button.png) no-repeat center;
											background-color: #00a9ff;
											width:100px;
											height: 36px;
											border-radius: 5px;
											text-align: center;
											line-height: 36px;
											cursor: pointer;
											display: block;
										}
									}
								}
								}
								.rank_body_r{
									width: 373px;
									padding-left: 40px;
									box-sizing: border-box;
									.rank_body_r2{
										color:#26adbd;
										font-size: 14px;
										margin-bottom: 20px;
										span{
										width: 50%;
										}
									}
									.rank_body_r3{
										position: relative;
										overflow: hidden;
										height: 100%;
										padding:5px 0 5px 5px;
										.grogress_box{
										position: relative;
										.grogress_item{
											position: relative;
											margin-right: 10px;
											a{
												cursor: pointer;
											}
											.grogress_text{
												position: absolute;
												top: 50%;
												left:50%;
												transform: translate(-50%,-50%);
												.grogress_price{
													text-align: center;
													white-space:nowrap;
													font-size: 20px;
													font-weight: 700;
												}
												.grogress_type{
													white-space:nowrap;
													font-size: 12px;
													color:#2e6d90;
													text-align: center;
												}
											}
										}
									}
										
										.overThree{
										background: url(https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/cover.png) no-repeat center;
										width: 153px;
										height: 100%;
										position: absolute;
										top: -1px;
										right: 0;
										i.moveL{
											display: none;
											width: 16px;
											height: 16px;
											border-left: 3px solid #58effa;
											border-bottom: 3px solid #58effa;
											transform: rotate(45deg) translate(0,-50%);
											position: absolute;
											top: 50%;
											right: 30px;
											cursor: pointer;
										}
										i.moveR{
											display: inline-block;
											width: 16px;
											height: 16px;
											border-right: 3px solid #58effa;
											border-bottom: 3px solid #58effa;
											transform: rotate(-45deg) translate(0,-50%);
											position: absolute;
											top: 50%;
											right: 5px;
											cursor: pointer;
										}
										}
									}
								}
							}
							.rank_item_comment{
								margin-top: 30px;
								.comment_item{
								flex-wrap: wrap;
								.rank_comment_pic{
									width: 60px;
									height: 60px;
									border-radius: 50%;
									overflow: hidden;
									margin-right: 10px;
									img{
									width: 60px;
									}
								}
								.rank_comment_text{
									padding-top: 15px;
									position: relative;
									height: 46px;
									overflow: hidden;
									width: 1109px;
									p{
										width: 1086px;
										color: #26adbd;
										overflow: hidden;
										line-height: 30px;
									.comment_name{
										font-size: 17px;
										color:#fff;
									}
									.comment_status{
										color:#54e7f2;
									}
									}
									i{
									display: inline-block;
									width: 10px;
									height: 10px;
									border-right: 2px solid #fff;
									border-bottom: 2px solid #fff;
									transform: rotate(-45deg);
									position: absolute;
									top: 27px;
									right: 4px;
									}
								}
								.rank_open_text{
									overflow: visible;
									height: 100%;
									i{
									transform: rotate(45deg);
									}
								}
								}
								
							
							}
						}
						#rankItemId.rank_no1{
							.rank_body_l{
								width: 744px;
								.rank_body_ll{
									background: url(https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/effect_bgc.png) no-repeat center;
									width: 455px;
									height: 241px;
									img{
										width: 90%;
									}
									.rank_flag{
										background: url(https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/NO1.png) no-repeat center;
										width: 66px;
										height: 51px;
										color:#fff;
									} 
								}
								.rank_body_lr{
									width: 289px;
									display: flex;
									flex-direction: column;
									align-items: flex-start;
									justify-content: space-between;
									.rank_carName{
										width: 100%;
										font-size: 28px;
										font-weight: 700;
										line-height: 36px;
									}
									.rank_mark_t{
										font-size: 18px;
										color:#26adbd;
										position: relative;
										top:16px;
									}
									.rank_mark{
										width: 100%;
										text-align: left;
										font-size: 50px;
										span{
										font-size: 110px;
										font-weight: 700;
										margin-right: 5px;
										}
									}
								} 
							}
							.rank_body_r{
								width: 436px;
								.rank_body_r1{
									display: flex;
									align-items: center;
									justify-content: flex-end;
									height: 60px;
									.rank_price{
										font-size: 18px;
									}
									.rank_detail_btn{
										margin-left: 15px;
										background: url(https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/button.png) no-repeat center;
										background-color: #00a9ff;
										width:100px;
										height: 36px;
										border-radius: 5px;
										text-align: center;
										line-height: 36px;
										cursor: pointer;
										display: block;
									}
									}
									.rankTab2{
										display:flex;
										justify-content: space-between;
										margin-bottom: 40px;
									}
									.rank_body_r2{
										color:#26adbd;
										font-size: 16px;
										margin-bottom: 20px;
										margin-top: 20px;
										line-height: 25px;
										}
									.rank_body_r3{
										.grogress_item{
										margin-right: 15px;
										.grogress_price{
											font-size: 26px;
										}
										.grogress_type{
											font-size: 12px;
										}
									}
									
								}
							}
						}
					}
				}
				.expect{
					text-align: center;
					color: #2e6d90;
					padding-top: 30px;
				}
			}
			.bestrank{
				margin-top: 70px;
				.bestrank_title{
					background-position: center top;
					background-repeat: no-repeat; 
					width:567px;
					height: 81px;
					margin: 0 auto 50px;
				}
				.review{
					.review_t{
						background: url(https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/title_review.png) no-repeat center;
						width:257px;
						height: 62px;
						margin: 50px auto 30px;
					}
					.review_outerbox{
						position: relative;
						.review_box{
							width: 100%;
							overflow: hidden;
							.review_b{
								display:flex;
								width: 5000px;
								position: relative;
								.review_b_item{
									background-position: center top;
									background-repeat: no-repeat;
									width: 360px;
									height: 298px;
									margin-right: 45px;
									a{
										height: 100%;
										width: 100%;
										display: inline-block;
										padding:25px;
										box-sizing: border-box;
										cursor: pointer;
										.review_img{
											width: 310px;
											height: 155px;
											position: relative;
											overflow: hidden;
											margin-bottom: 15px;
											border-radius: 5px;
											img{
												width: 100%;
												position: absolute;
												top: 50%;
												transform: translate(0,-50%);
											}
										}
										h5{
											line-height: 25px;
											margin-bottom: 10px;
											color:#fff;
											height: 50px;
											display: -webkit-box;
											-webkit-box-orient: vertical;
											-webkit-line-clamp: 2;
											overflow: hidden;
										}
										h6{
											font-size: 14px;
											color:#2e6d90;
										}
									}
								}
							}
						}
						.review_moveL{
							background: url(https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/arrow_l.png) no-repeat center;
							width: 36px;
							height: 72px;
							position: absolute;
							top:50%;
							left:-40px;
							transform: translate(0,-50%);
							z-index: 10;
						}
						.review_moveR{
							background: url(https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/arrow_r.png) no-repeat center;
							width: 36px;
							height: 72px;
							position: absolute;
							top:50%;
							right:-40px;
							transform: translate(0,-50%);
							z-index: 10;
						}
					}
				}
				.summary{
					.summary_t{
						background: url(https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/title_summary.png) no-repeat center;
						width: 257px;
						height: 62px;
						margin:50px auto 30px;
					}
					.summary_box{
						width: 100%;
						display: flex;
						flex-wrap: wrap;
						.summary_item{
							background-position: center top;
							background-repeat: no-repeat;
							width: 262px;
							height: 218px;
							margin-right: 42px;
							margin-bottom: 30px;
							a{
								height: 100%;
								width: 100%;
								display: inline-block;
								padding:20px;
								box-sizing: border-box;
								.summary_img{
									width: 222px;
									max-height: 126px;
									position: relative;
									overflow: hidden;
									margin-bottom: 15px;
									border-radius: 5px;
									img{
										width: 100%;
									}
									i{
										position: absolute;
										bottom: 5px;
										right:5px;
										z-index: 10;
									}
									em{
										background: url(https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/play_btn.png) no-repeat center;
										width: 50px;
										height: 50px;
										background-size: 50px 50px;
										position: absolute;
										top: 50%;
										left:50%;
										transform: translate(-50%,-50%);
									}
								}
								h5{
									text-align: center;
									max-height: 45px;
									overflow: hidden;
								}
							}
						}
						.summary_item:nth-of-type(4n){
							margin-right: 0px;
						}
					}
					.hiddenMore{
						height: 218px;
						overflow: hidden;
						}
					.btn_more{
						margin:35px auto;
						border: 1px solid #1f5093;
						color:#1f5093;
						width: 120px;
						height: 40px;
						line-height: 40px;
						text-align: center;
						cursor: pointer;
						border-radius: 5px;
					}
				}
			}
			.recommend{
				.recommend_t{
					background-position: center top;
					background-repeat: no-repeat;
					width: 568px;
					height: 82px;
					margin:50px auto 30px;
				}
				.recommend_box{
					display: flex;
					flex-wrap: wrap;
					.recommend_item{
						background-position: center top;
						background-repeat: no-repeat;
						width: 561px;
						height: 402px;
						padding:25px;
						box-sizing: border-box;
						margin-right: 50px;
						margin-bottom: 30px;
						background-size: 100% 100%;
						a{
							cursor: pointer;
						}
						.recommend_img{
							width: 100%;
							max-height: 310px;
							position: relative;
							overflow: hidden;
							margin-bottom: 15px;
							border-radius: 5px;
							img{
								width: 100%;
							}
							.authorFaceBox{
								position: absolute;
								left: 5px;
								bottom: 5px;
								max-height: 100px;
								overflow: hidden;
								width: 100%;
								i{
									border-radius: 5px;
									overflow: hidden;
									margin-right: 10px;
									img{
										width: 40px;
									}
								}
								em{
									position: absolute;
									top: 50%;
									transform: translate(0,-50%);
									color:#fff;
									font-weight: 700;
									font-size: 18px;
								}
								
							}
						}
						.recommend_text{
							h5{
								max-width: 430px;
								white-space: nowrap;
								overflow: hidden;
								text-overflow:ellipsis
							}
							a{
								cursor: pointer;
							}
						}
					}
					.recommend_item:nth-of-type(2n){
						margin-right: 0;
					}
				}
			}
			.bottom_flag{
				text-align: center;
				color: #1f5093;
				margin-top: 30px;
			}
		}
	}
	.getmore{
		background: url(https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/button.png) no-repeat center;
		background-color: #00a9ff;
		background-size: 100% 100%;
		width: 120px;
		border-radius: 5px;
		text-align: center;
		line-height: 36px;
		cursor: pointer;
		font-size: 16px;
		margin: 30px auto 0;
	}
</style>


// WEBPACK FOOTER //
// src/pages/index.vue